import Vue from "vue";
import Vuex from "vuex";
import Swal from "sweetalert2";
// import VueI18n from 'vue-i18n';
import i18n from '../message.js';

Vue.use(Vuex);
// Vue.use(VueI18n);

export default new Vuex.Store({
  state: {
    qIndex: 0,
    title: "abc",
    examdate: "",
    users: {},
    exams: {},
    consentClick: "",
    token: localStorage.getItem("token") || "",
    examid: "",
    duration: "",
    examClick: [],
    status: "",
    one_id_token: localStorage.getItem("one_id_token") || "",
    preview_token: localStorage.getItem('preview_token') || '',
    exam_timeout: '0',
    company_id: localStorage.getItem('company_id') || '',
    company_user_id: localStorage.getItem('company_user_id') || '',
    themeColor: JSON.parse(localStorage.getItem('themeColor')) || '',
    themeSite: JSON.parse(localStorage.getItem('themeSite')) || '',
  },
  getters: {
    isLoggedIn: state => !!state.token,
    qIndex: (state) => state.qIndex,
    usersFullName(state) {
      if (state.users.name != null && state.users.surname != null) {
        return state.users.name + ' ' + state.users.surname
      } else {
        return null
      }
    },
    usersUsername: (state) => state.users.username,
    // usersFullName(state){
    //   return state.users.name+' '+state.users.surname
    // },
    // usersTitle: (state) => state.users.title,
    getExams: (state) => state.exams,
    consentClick: (state) => state.consentClick,
    token: (state) => state.token,
    examid: (state) => state.examid,
    duration: (state) => state.duration,

    themeColor: (state) => state.themeColor,
    themeSite: (state) => state.themeSite,
    company_id: state => state.company_id,
    company_user_id: state => state.company_user_id,
    preview_token: state => state.preview_token,
    exam_timeout: state => state.exam_timeout,
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, payload) {
      state.status = "success";
      state.token = payload.token;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.one_id_token = "";
      localStorage.removeItem("one_id_token");
      localStorage.removeItem("token");
      localStorage.removeItem('username')
      localStorage.removeItem('password')
      localStorage.removeItem("time")
      localStorage.removeItem('company_id')
      localStorage.removeItem('company_user_id')
      localStorage.removeItem('themeColor')
      localStorage.removeItem('themeSite')
      localStorage.removeItem('LOGIN_BY_SHARE_TOKEN')
      localStorage.removeItem('callback')
      localStorage.removeItem('language')
    },
    closePreview() {
      localStorage.removeItem('preview_token')
      localStorage.removeItem('themeColor')
      localStorage.removeItem('company_id')
      localStorage.removeItem('language')
    },
    questionNextIndex(state) {
      state.qIndex++;
    },
    questionPrevIndex(state) {
      state.qIndex--;
    },
    questionSelectIndex(state, data) {
      state.qIndex = data;
    },
    SET_USERS(state, users) {
      state.users = users;
    },
    SET_EXAMS(state, exams) {
      state.exams = exams;
    },
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    SET_EXAM_ID(state, examid) {
      state.examid = examid;
    },
    SET_DURATION(state, duration) {
      state.duration = duration;
    },
    SET_CONSENT_CLICK(state, consentClick) {
      state.consentClick = consentClick;
    },
    SET_EXAM_CLICK(state, examClick) {
      // state.examClick = examClick;
      state.examClick.splice(examClick.questionIndex, 1, examClick);
    },

    setPreviewToken(state, data) {
      state.preview_token = data
      localStorage.setItem('preview_token', data)
    },

    toTimeout(state, data) {
      state.exam_timeout = data
    },

    setCompanyId(state, data) {
      state.company_id = data
      localStorage.setItem('company_id', data)
    },
    setCompanyUserId(state, data) {
      state.company_user_id = data
      localStorage.setItem('company_user_id', data)
    },
    setThemeColor(state, data) {
      state.themeColor = data;
      localStorage.setItem('themeColor', JSON.stringify(data))
    },
    setThemeSite(state, data) {
      state.themeSite = data;
      localStorage.setItem('themeSite', JSON.stringify(data))
    },
    setExamLink(state, data) {
      localStorage.setItem("setExamLink", data);
    },
    removeExamLink() {
      localStorage.removeItem("setExamLink");
    },
    setShareTokenStatus(state, data) {
      localStorage.setItem('LOGIN_BY_SHARE_TOKEN', data)
    },
    setCallback(state, data) {
      localStorage.setItem('callback', data)
    },
  },
  actions: {
    async login({ commit }, user) {
      try {
        await Vue.axios({
          url: `${process.env.VUE_APP_BACKEND_API}/login`,
          data: user,
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
        }).then((resp) => {
          // console.log(resp.data);
          const token = resp.data.data.access_token;
          const username = resp.data.data.user.username;
          const password = resp.data.data.user.password;
          localStorage.setItem("token", token);
          localStorage.setItem("username", username);
          localStorage.setItem("password", password);
          commit("setCompanyUserId", resp.data.data.user.company_id)
          // console.log(response);
          // console.log("token", token);
          // console.log("username", username);
          // const one_id_token = response.data.access_token;
          // localStorage.setItem("one_id_token", one_id_token);
          commit("auth_success", { token: token, username: username, password: password });
        });
      } catch (err) {
        commit("auth_error");
        localStorage.removeItem("token");
        Swal.fire({
          icon: "error",
          title: i18n.t("textErr"),
          text: i18n.t("UnableLogin"),
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },
    async loginByShareToken({ commit }, shared_token) {
      try {
        await Vue.axios({
          url: `${process.env.VUE_APP_BACKEND_API}/login_shared_token`,
          data: shared_token,
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
        }).then((resp) => {
          // console.log(resp.data);
          const token = resp.data.data.access_token;
          const username = resp.data.data.user.username;
          const password = resp.data.data.user.password;
          localStorage.setItem("token", token);
          localStorage.setItem("username", username);
          localStorage.setItem("password", password);
          commit("setCompanyUserId", resp.data.data.user.company_id)
          // console.log(response);
          // console.log("token", token);
          // console.log("username", username);
          // const one_id_token = response.data.access_token;
          // localStorage.setItem("one_id_token", one_id_token);
          commit("auth_success", { token: token, username: username, password: password });
        });
      } catch (err) {
        commit("auth_error");
        localStorage.removeItem("token");
        Swal.fire({
          icon: "error",
          title: i18n.t("textErr"),
          text: i18n.t("UnableLogin"),
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },

    getUsers({ commit }, payload) {
      commit("SET_USERS", payload);
    },
    getExams({ commit }, payload) {
      commit("SET_EXAMS", payload);
    },
    // getToken({ commit }, payload) {
    //   commit("SET_TOKEN", payload);
    // },
    getExamid({ commit }, payload) {
      commit("SET_EXAM_ID", payload);
    },
    getDuration({ commit }, payload) {
      commit("SET_DURATION", payload);
    },
    getConsentClick({ commit }, payload) {
      commit("SET_CONSENT_CLICK", payload);
    },
    //Exam
    async getExamClick({ commit, getters }, payload) {
      commit("SET_EXAM_CLICK", payload.payload);
      //Put Update to Database

      let updateAnswer = {}
      if (payload.payload_all_status == true) {
        updateAnswer = {
          exam_id: payload.payload.exam_id,
          answers: payload.payload_all
          // duration: getters.getExams.parm.duration,
        };
      } else {
        updateAnswer = {
          exam_id: payload.payload.exam_id,
          answers: [{
            item_id: payload.payload.item_id,
            type: payload.payload.type,
            ans: payload.payload.ans,
            doc: payload.payload.doc,
            pic: payload.payload.pic,
          }]
          // duration: getters.getExams.parm.duration,
        };
      }

      await Vue.axios({
        url: `${process.env.VUE_APP_BACKEND_API}/api/update/answer`,
        data: updateAnswer,
        method: "PUT",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${getters.token}`,
        },
      })
      // .then((resp) => {
      //   // console.log("axios login resp ")
      //   if (resp.status != 200) {
      //     console.log("update ans = ", resp);
      //   }
      //   // const token = resp.data.access_token
      //   // const user = resp.data.user

      //   // localStorage.setItem('token', token)
      //   // Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      //   // commit('auth_success', { token: token, user: user })
      //   // resolve(resp)
      // })
      // .catch((err) => {
      //   console.log(err);
      //   // Swal.fire({
      //   //   icon: "error",
      //   //   title: "ผิดพลาด",
      //   //   text: err.message,
      //   //   showConfirmButton: false,
      //   //   timer: 3000,
      //   // });
      // });
    },
    //Exam
    endExam({ commit, getters }, payload) {
      // commit("SET_EXAM_CLICK");
      //Put Update to Database
      // console.log("endExam", payload);
      let endExamPayload = {
        username: getters.usersUsername,
        exam_id: getters.examid,
        send_exam: payload,
      };
      // console.log("payload", endExamPayload);
      const shared_token_status = localStorage.getItem('LOGIN_BY_SHARE_TOKEN') || '0'
      const url_callback = localStorage.getItem('callback') || null
      const language = localStorage.getItem('language')
      Vue.axios({
        url: `${process.env.VUE_APP_BACKEND_API}/api/sendAnswer`,
        data: endExamPayload,
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${getters.token}`,
        },
      })
        .then((resp) => {
          // console.log(resp);
          let result = resp.data.result;
          let score = 0;
          let text = "";
          if (typeof resp.data.score !== "undefined") {
            score = resp.data.score;
          }
          if (result == "W") {
            Swal.fire({
              icon: "success",
              title: i18n.t("wait_for_inspection"),
              showConfirmButton: false,
              timer: 3000,
            }).then(() => {
              if (getters.exam_timeout == '1') {
                // window.location.href = "/timeout";
                const url = location.origin + "/timeout";
                window.location.replace(url);
              } else {
                if (shared_token_status == '1' && url_callback != null) {
                  // window.location = url_callback
                  window.location.replace(url_callback);
                } else {
                  // window.location.href = "/";
                  const url = location.origin + "/";
                  window.location.replace(url);
                }
              }
            });
          } else if (result == "N") {
            if (getters.getExams.parm.show_score == "Y" && language == 'th') {
              text =
                "<h5>ผลการสอบ : <strong>ไม่ผ่าน</strong><br> ได้คะแนน " +
                score +
                "/" +
                getters.getExams.parm.total_score +
                "</h5>";
            } else if (getters.getExams.parm.show_score == "Y" && language == 'en') {
              text =
                "<h5>Examination results : <strong>Fail</strong><br> Score " +
                score +
                "/" +
                getters.getExams.parm.total_score +
                "</h5>";
            } else if (getters.getExams.parm.show_score == "S" && language == 'th') {
              text =
                "<h5>ได้คะแนน " + score + "/" +
                getters.getExams.parm.total_score +
                "</h5>";
            } else if (getters.getExams.parm.show_score == "S" && language == 'en') {
              text =
                "<h5>Score " + score + "/" +
                getters.getExams.parm.total_score +
                "</h5>";
            } else if (getters.getExams.parm.show_score == "R" && language == 'th') {
              text =
                "<h5>ผลการสอบ : <strong>ไม่ผ่าน</strong></h5>";
            } else if (getters.getExams.parm.show_score == "R" && language == 'en') {
              text =
                "<h5>Examination results : <strong>Fail</strong></h5>";
            }
            // else {
            //   text = "<h5>ผลการสอบ : <strong>ไม่ผ่าน</strong></h5>";
            // }
            Swal.fire({
              icon: "success",
              title: i18n.t("successful_submit"),
              html: text,
              showConfirmButton: false,
              timer: 3000,
            }).then(() => {
              if (getters.exam_timeout == '1') {
                // window.location.href = "/timeout";
                const url = location.origin + "/timeout";
                window.location.replace(url);
              } else {
                if (shared_token_status == '1' && url_callback != null) {
                  // window.location = url_callback
                  window.location.replace(url_callback);
                } else {
                  // window.location.href = "/";
                  const url = location.origin + "/";
                  window.location.replace(url);
                }
              }
            });
          } else if (result == "Y") {
            if (getters.getExams.parm.show_score == "Y" && language == 'th') {
              text = language +
                "<h5>ผลการสอบ : <strong>ผ่าน</strong> ได้คะแนน " +
                score +
                "/" +
                getters.getExams.parm.total_score +
                "</h5>";
            } else if (getters.getExams.parm.show_score == "Y" && language == 'en') {
              text =
                "<h5>Examination results : <strong>Pass</strong><br> Score " +
                score +
                "/" +
                getters.getExams.parm.total_score +
                "</h5>";
            } else if (getters.getExams.parm.show_score == "S" && language == 'th') {
              text =
                "<h5>ได้คะแนน " + score + "/" +
                getters.getExams.parm.total_score +
                "</h5>";
            } else if (getters.getExams.parm.show_score == "S" && language == 'en') {
              text =
                "<h5>Score " + score + "/" +
                getters.getExams.parm.total_score +
                "</h5>";
            } else if (getters.getExams.parm.show_score == "R" && language == 'th') {
              text =
                "<h5>ผลการสอบ : <strong>ผ่าน</strong></h5>";
            } else if (getters.getExams.parm.show_score == "R" && language == 'en') {
              text =
                "<h5>Examination results : <strong>Pass</strong></h5>";
            }
            // else {
            //   text = "<h5>ผลการสอบ : <strong>ผ่าน</strong></h5>";
            // }
            Swal.fire({
              icon: "success",
              title: i18n.t("successful_submit"),
              html: text,
              showConfirmButton: false,
              timer: 3000,
            }).then(() => {
              if (getters.exam_timeout == '1') {
                // window.location.href = "/timeout";
                const url = location.origin + "/timeout";
                window.location.replace(url);
              } else {
                if (shared_token_status == '1' && url_callback != null) {
                  // window.location = url_callback
                  window.location.replace(url_callback);
                } else {
                  // window.location.href = "/";
                  const url = location.origin + "/";
                  window.location.replace(url);
                }
              }
            });
          } else {
            Swal.fire({
              icon: "success",
              title: i18n.t("successful_submit"),
              showConfirmButton: false,
              timer: 3000,
            }).then(() => {
              if (getters.exam_timeout == '1') {
                // window.location.href = "/timeout";
                const url = location.origin + "/timeout";
                window.location.replace(url);
              } else {
                if (shared_token_status == '1' && url_callback != null) {
                  // window.location = url_callback
                  window.location.replace(url_callback);
                } else {
                  // window.location.href = "/";
                  const url = location.origin + "/";
                  window.location.replace(url);
                }
              }
            });
          }
          // localStorage.setItem('token', token)
          // Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
          // commit('auth_success', { token: token, user: user })
          // resolve(resp)
        })
        .catch((err) => {
          let icon = ''
          let title = ''
          let err_message = ''
          if (err == 'Network Error') {
            icon = 'warning'
            title = i18n.t("textWarning")
            err_message = i18n.t("network_unstable")
          } else {
            icon = 'error'
            title = i18n.t("textErr")
            err_message = err.message
          }
          Swal.fire({
            icon: icon,
            title: title,
            text: err_message,
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            if (err != 'Network Error') {
              if (shared_token_status == '1' && url_callback != null) {
                // window.location = url_callback
                window.location.replace(url_callback);
              } else {
                // window.location.href = "/";
                const url = location.origin + "/";
                window.location.replace(url);
              }
            }
          });
        });
      commit("removeExamLink");
    },

    async getThemeColor({ commit }, data) {
      if (data == 'site') {
        const response = await Vue.axios.get(`${process.env.VUE_APP_BACKEND_API}/api/company/manage/` + localStorage.getItem("company_user_id"), {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token")
          }
        })
        let payload_site = {}
        payload_site = {
          primary_color: response.data.data.theme_color,
          logo_site: response.data.data.logo,
        }
        commit("setThemeSite", payload_site);
      } else {
        const tokentotheme = localStorage.getItem("token") || localStorage.getItem('preview_token')
        const response = await Vue.axios.get(`${process.env.VUE_APP_BACKEND_API}/api/company/manage/` + localStorage.getItem("company_id"), {
          headers: {
            'Authorization': 'Bearer ' + tokentotheme
          }
        })
        let payload_color = {}
        payload_color = {
          primary_exam: response.data.data.theme_color,
          logo_exam: response.data.data.logo,
        }
        commit("setThemeColor", payload_color);
      }
    },
  },
  modules: {},
});
